import ResponsiveNavigationClass from '@morsedigital/vanilla-responsive-navigation';
import BannerCarousel from '../modules/banner_carousel';
import { EventListener as utilities, Cookiebar } from '@morsedigital/morse-utils';
import '../modules/pollyfills';
import '../modules/font_observer';
import '../modules/load_service_worker';
import '../modules/dynamic_pages';
import lozad from 'lozad';

// (() => {
//   Rails.start();
// })();

(() => {
  // Lazy load images
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();
})();
(() => {
  utilities([Cookiebar('cookie-prompt')]);
})();
(() => {
  const landingPageNavigation = new ResponsiveNavigationClass('landing-page-navigation', {
    list_id: 'landing-page-navigation-list',
    toggle_id: 'landing-page-navigation-toggle',
    toggle_mobile_id: null,
    flyout: true,
  });

  if (landingPageNavigation && Object.prototype.hasOwnProperty.call(landingPageNavigation, 'config')) {
    landingPageNavigation._init();
  }
})();

(() => {
  const map = document.getElementById('google-map');

  if (map) {
    import(/* webpackChunkName: "map" */ '@djforth/gmaps_helper').then(({ default: Maps }) => {
      Maps('AIzaSyCNO6nOBSGTYverQD5nFnwUG_h-O206NfI').load();
    });
  }
})();

(() => {
  BannerCarousel();
})();
